'use client';

import RenderAd from '@pickleballinc/ui/components/advertisements/render-ad';

import { ZONE_IDS } from '@/lib/ads.types';
import { env } from '@/lib/env.mjs';
import { useLocation } from '@/lib/location/location';

interface AdvertisementBannerProps {
	isHomepage?: boolean;
}

export const AdvertisementBanner = ({ isHomepage }: AdvertisementBannerProps) => {
	const { location } = useLocation();

	return (
		<div className={`mx-auto w-full pt-4 ${isHomepage ? 'px-4' : ''}`}>
			<RenderAd
				zoneId={ZONE_IDS.NEW_BANNER}
				pageId={100009}
				place={0}
				ipAddress={location?.query}
				isProd={env.NEXT_PUBLIC_APP_ENV === 'prod'}
				containerClassname="mx-auto"
				showFromWidth={600}
			/>
		</div>
	);
};
